import React, { useEffect, useState }  from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { FILTER_VALUE_ACTIVOS, FILTER_VALUE_FINALIZADOS, FILTER_VALUE_MIS_CHATS } from "../../../const/filtersValue/filterValue";
import { getChats } from "../../../helpers/fetch/getChats";
import { getChatsFinish } from "../../../helpers/fetch/getChatsFinish";
import { userIsAdmin } from "../../../const/conditionalConstants/userIsAdmin";
import FavoriteIcon from '@mui/icons-material/Favorite';

// TabFilter: Componente que renderiza un filtro de chats en forma de TABS.

const TabFilter = ({ setChats, setFilterValue, filterValue, setLoading, number }) => {
    
    const isAdmin = userIsAdmin(); //Verificar si el usuario es o no admin.
    let fontSizeTab = 14; //Tamaño del texto de los Tabs para filtrar los Chats.
    const tabStyle = { fontFamily: 'Poppins', fontSize: `${fontSizeTab}px`,
     width: isAdmin ? "33.3%" : "50%", textTransform: "none", color: "#96989A" }
    const [numberActiveChats, setNumberActiveChats] = useState(0); //Estado para guardar la cantidad de chats activo.
    const [numberMisChats, setNumberMisChats] = useState(0); //Estado para guardar la cantidad de mis chats si soy admin.

    //Función para actualizar el valor del TAB.
    const handleChange = (event, newValue) =>  {
        setChats([])
        setFilterValue(newValue); //Actualizar al nuevo filtro.
        setLoading(true); //Renderizar el Cargando hasta que concluya la petición de Chats.
        handleChangeTab(newValue); 
    };

    const handleChangeTab = async (filter) => { //Función para traer los chats finalizados.
        try {
            let responseChats = null;
            if (filter === FILTER_VALUE_FINALIZADOS){ //Traer los chats finalizados.
                responseChats = await getChatsFinish({ 
                    filter: filter, 
                    idLastChatPosition: 0, 
                }); // Invoca a la función para traer los chats finalizados.  
            }
            else if(filter === FILTER_VALUE_ACTIVOS){ //Traer los chats activos.
                responseChats = await getChats({ 
                    filter: filter, 
                }); // Invoca a la función para traer los chats activos.
            }
            else if(filter === FILTER_VALUE_MIS_CHATS){ //Traer los chats que le pertenezcan solo al usuario logeado.
                let responseChats_activos = await getChats({ 
                    filter: FILTER_VALUE_ACTIVOS, 
                }); // Invoca a la función para traer los chats activos.
                let userData = JSON.parse(localStorage.getItem("userData")); //Traer los datos del usuario para filtrar por su id.
                let responseChats_activosFiltered = responseChats_activos.filter((chat) => chat.IdUsuarioAsignado === userData.IdUsuario)
                if (responseChats_activosFiltered.length > 0) responseChats = responseChats_activosFiltered;
            }

            if (responseChats) {
                setChats(responseChats);
                setLoading(false);
            }
        } catch (error) {
            console.error("Error al obtener los chats:", error);
            setLoading(false); // Detener la carga en caso de error.
        }
    };

    useEffect(() => {
        const changeNumberTabvalue = () => {
            if (filterValue === FILTER_VALUE_ACTIVOS){ //Si estamos en el filtro de activos.
                setNumberActiveChats(number); //Actualizamos el valor de los chats dentro de ese filtro.
            }
            else if (filterValue === FILTER_VALUE_MIS_CHATS){ //Si estamos en el filtro de mis chats.
                setNumberMisChats(number); //Actualizar el valor de los chats dentro de ese filtro.
            }
        }
        changeNumberTabvalue();
    }, [filterValue, number])

    return (
        <Tabs value={filterValue} onChange={handleChange} aria-label="Estados" sx={{ borderBottom: '0.1px solid #7c7c7c' }} >
            {isAdmin && <Tab value={FILTER_VALUE_MIS_CHATS} label={`Mis Chats (${numberMisChats !== 0 ? numberMisChats : ""})`}  sx={tabStyle} />}
            <Tab value={FILTER_VALUE_ACTIVOS} label={`Activos (${numberActiveChats !== 0 ? numberActiveChats : ""})`}  sx={tabStyle} /* icon={number} */ iconPosition="end"/>
            <Tab value={FILTER_VALUE_FINALIZADOS} label="Finalizados"  sx={tabStyle} />
        </Tabs>
    )

};

export default TabFilter;